/* __next_internal_client_entry_do_not_use__ TopOfPageContentWrapper auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isIdentityVerificationModalOrRoute } from "@faire/retailer-visitor-shared/components/App/AppModals/isIDV";
import { useShouldShowSaleAnnouncementNudge } from "@faire/retailer-visitor-shared/components/Header/desktop/SaleAnnouncementNudge/useShouldShowSaleAnnouncementNudge";
import { useNotificationPreview } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useNotificationPreview";
import { useNotificationRefetch } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useNotificationRefetch";
import { HeaderPriorityProvider, useHeaderPriorityStore } from "@faire/retailer-visitor-shared/components/HeaderPriorityRenderer/HeaderPriorityPriovider";
import { AppNudgeProvider } from "@faire/retailer-visitor-shared/features/Nudges/useAppNudgeStore";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";
import { useStickyNavContentPositions } from "@faire/retailer-visitor-shared/navbar/useStickyNavContentPositions";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import React, { useEffect } from "react";
import { ToastContainer } from "./ToastContainer";
import { useClassName } from "./useClassName";
import { useNonStickyHeader } from "./useNonStickyHeader";
import { useResizeRefCallback } from "./useResizeRefCallback";
import { useStyle } from "./useStyle";
export var TopOfPageContentWrapper = function(param) {
    var children = param.children, hasNoTopBanner = param.hasNoTopBanner, hasToastContainer = param.hasToastContainer;
    useNotificationRefetch();
    var notificationPreview = useNotificationPreview();
    return /*#__PURE__*/ _jsx(HeaderPriorityProvider, {
        value: {
            isNotificationPreviewVisible: !!notificationPreview
        },
        children: /*#__PURE__*/ _jsx(TopOfPageContentWrapperBase, {
            hasNoTopBanner: hasNoTopBanner,
            hasToastContainer: hasToastContainer,
            children: children
        })
    });
};
var TopOfPageContentWrapperBase = function(param) {
    var children = param.children, hasNoTopBanner = param.hasNoTopBanner, hasToastContainer = param.hasToastContainer;
    var shouldRetainOriginalPosition = useStickyNavContentPositions().shouldRetainOriginalPosition;
    var _useShouldShowSaleAnnouncementNudge = useShouldShowSaleAnnouncementNudge(), shouldShowSaleAnnouncementTooltip = _useShouldShowSaleAnnouncementNudge.shouldShowSalesHubNudge;
    var _useHeaderPriorityStore = _sliced_to_array(useHeaderPriorityStore([
        "isNotificationPreviewVisible"
    ]), 1), isNotificationPreviewVisible = _useHeaderPriorityStore[0].isNotificationPreviewVisible;
    var shouldHideTopNav = useIsLoggedInRetailer();
    var setHeaderHeight = useTopOfPageContent().setHeaderHeight;
    var bannerHeight = usePromoBanners().bannerHeight;
    var _useMarketStore = useMarketStore([
        "isShowingCountdownBanner"
    ]), isShowingMarketCountdownBanner = _useMarketStore.isShowingCountdownBanner;
    var notificationPreview = useNotificationPreview();
    var hasLinkedPOS = usePOSSummary().hasLinkedPOS;
    var _useResizeRefCallback = useResizeRefCallback(), contentCallback = _useResizeRefCallback.contentCallback, contentRef = _useResizeRefCallback.contentRef;
    var nonStickyHeader = useNonStickyHeader({
        hasLinkedPOS: hasLinkedPOS
    });
    useEffect(function() {
        if (!shouldHideTopNav || nonStickyHeader) {
            return;
        }
        if (shouldRetainOriginalPosition) {
            var _contentRef_current;
            var _contentRef_current_clientHeight;
            setHeaderHeight((_contentRef_current_clientHeight = (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.clientHeight) !== null && _contentRef_current_clientHeight !== void 0 ? _contentRef_current_clientHeight : 0);
        } else {
            setHeaderHeight(0);
        }
    }, [
        shouldHideTopNav,
        shouldRetainOriginalPosition,
        nonStickyHeader,
        setHeaderHeight,
        contentRef
    ]);
    var style = useStyle({
        bannerHeight: bannerHeight,
        contentRef: contentRef,
        hasNoTopBanner: hasNoTopBanner,
        isNotificationPreviewVisible: isNotificationPreviewVisible,
        isShowingMarketCountdownBanner: isShowingMarketCountdownBanner,
        nonStickyHeader: nonStickyHeader,
        notificationPreview: notificationPreview,
        shouldRetainOriginalPosition: shouldRetainOriginalPosition,
        shouldShowSaleAnnouncementTooltip: shouldShowSaleAnnouncementTooltip
    });
    var className = useClassName({
        nonStickyHeader: nonStickyHeader,
        shouldRetainOriginalPosition: shouldRetainOriginalPosition
    });
    if (isMobileApp() && isIdentityVerificationModalOrRoute()) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AppNudgeProvider, {
                children: /*#__PURE__*/ _jsx("div", {
                    "data-test-id": "header-content",
                    ref: contentCallback,
                    className: className,
                    style: style,
                    children: children
                })
            }),
            hasToastContainer ? /*#__PURE__*/ _jsx(ToastContainer, {
                style: style
            }) : null
        ]
    });
};
